import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { addressSelector } from 'shared/selectors';

const MOSCOW_CITY_ID = 1;

export function useRegion() {
  const addresses = useSelector(addressSelector);
  const firstAddress = addresses[0];

  return useMemo(() => {
    if (firstAddress) {
      return {
        id: firstAddress.id,
        displayName: firstAddress.fullName,
      };
    }

    return {
      id: MOSCOW_CITY_ID,
    };
  }, [firstAddress]);
}
